// ==========================================
// 1. UPDATED Home.jsx
// ==========================================
import React, { useState, useEffect } from "react";
import NewsSection from "../../components/home/NewsSection";
import Loading from "../../components/common/Loading";
import {
  fetchBharatNews,
  fetchGlobalNews,
  fetchSportsNews,
  fetchFinanceNews,
  fetchGossipNews,
} from "../../services/api";
import AppNavbar from "../../components/common/AppNavbar";
import { Helmet } from "react-helmet";
import HomeExtra from "../../components/home/HomeExtra";
import Movies from "../../components/Entertainment/Movie";
import NewsBanner from "../../components/home/banner";
import BharatAbroadAd from "../../components/common/BharatAbroadAd";

function Home() {
  const [news, setNews] = useState({
    bharat: [],
    global: [],
    sports: [],
    finance: [],
    gossip: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadNews = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch all categories in parallel
        const [bharat, global, sports, finance, gossip] = await Promise.all([
          fetchBharatNews(),
          fetchGlobalNews(),
          fetchSportsNews(),
          fetchFinanceNews(),
          fetchGossipNews(),
        ]);

        setNews({ bharat, global, sports, finance, gossip });
        // console.log("News loaded successfully:", {
        //   bharat,
        //   global,
        //   sports,
        //   finance,
        // });
      } catch (err) {
        console.error("Error loading news:", err);
        setError("Failed to load news. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    loadNews();
  }, []);

  if (loading) return <Loading />;

  if (error) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          color: "#d32f2f",
        }}
      >
        <p>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: "20px",
            padding: "10px 24px",
            background: "#0066cc",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Latest Bharat News | IPL, Entertainment, Tech & Travel Updates
        </title>
        <meta
          name="description"
          content="Get the latest news from India and around the world on BharatAbroad. Stay updated with IPL 2026, cricket live scores, Bollywood news, technology, auto, health, travel, immigration, and more daily updates."
        />
        <meta
          name="keywords"
          content="India news today, BJP news, Modi government latest, Indian Parliament news, India election results 2026, India political news in English, NRI news India, India news for diaspora, Indian expat news, India breaking political news, Modi latest speech today, BJP vs Congress latest updates, Lok Sabha news today live, Rajya Sabha proceedings today, India election opinion polls, India political analysis 2026, Central government schemes India, India cabinet decisions today, Opposition parties India news, India policy reforms latest, Indian constitution updates news, Indian democracy news analysis, India governance reforms news, India political news live updates, Breaking news India politics today, India government latest announcement today, Live updates Lok Sabha session, Rajya Sabha live debate today, India top political news now, India political crisis latest news, India government press conference today, Modi government new policies 2026, PM Modi latest decisions today, Modi speech highlights today India, Modi international visits news, Modi government achievements latest, Modi schemes list 2026, Central government new rules India, PMO India updates today, India general election 2026 updates, State election results India today, Election campaign news India, BJP election strategy 2026, Congress party latest news India, Regional parties India politics, Election rallies India today, Voter turnout India elections, Election commission India updates, India exit poll predictions, New laws in India 2026, Government policy changes India, India law reforms latest news, Bills passed in Parliament today, India public policy analysis, Governance issues in India news, Administrative reforms India, India welfare schemes updates, Digital governance India news, Opposition leaders India news, India political debates today, BJP vs opposition latest clash, Parliament protests India today, Political controversy India latest, India coalition politics news, Party spokesperson statements India, Supreme Court India latest judgment, Constitutional amendment India news, Judiciary vs government India, PIL news India today, Legal reforms India government, Election law India updates, India foreign policy latest news, India US relations politics, India China border political updates, India Pakistan relations news, India diplomacy latest updates, India UN speech news, Global politics impact on India, State politics news India today, Chief minister news India, Tamil Nadu political news today, Maharashtra political updates, Karnataka government news, Delhi politics latest updates, West Bengal political news, Telangana politics today, NRI voting rights India news, Overseas Indians political news, India politics impact on NRIs, Diaspora reaction India politics, Global Indians political views, NRI opinion on India elections, How Indian Parliament works, What is Lok Sabha and Rajya Sabha, How elections work in India, India political system explained, Role of Prime Minister India, Powers of President of India, How laws are passed in India, India constitution explained simply, Big political update India today, Major decision by Modi government, Shocking political news India, Huge Parliament update today, Breaking India government decision, Top political headlines India today, Bharat Abroad, Bharat Global Network, NRI news, Indian diaspora, Bharat in USA, Bharat in UK, Bharat in Canada, IPL 2026, Bollywood news, Indian expat community, H1B visa updates, Green card news, Bharat entrepreneurs abroad, Bharat diaspora portal"
        />

        {/* Technical */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Bharat Abroad – Connecting Indians Worldwide"
        />
        <meta
          property="og:description"
          content="Join a global platform for Indians abroad. Explore culture, heritage, and community worldwide."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.bharatabroad.com/" />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/BharatAbroad.com.png"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://www.bharatabroad.com/" />
      </Helmet>
      <AppNavbar />

      <div
        style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}
      >
        {/* <NewsBanner /> */}
        <div id="container" style={{ maxWidth: "1400px", margin: "0 auto" }}>
          {/* Bharat Section */}
          <NewsSection
            title="Bharat News"
            articles={news.bharat}
            category="bharat"
          />
          <BharatAbroadAd />
          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Global Section */}
          <NewsSection
            title="Global News"
            articles={news.global}
            category="global"
          />
          <BharatAbroadAd />
          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Sports Section */}
          <NewsSection
            title="Sports News"
            articles={news.sports}
            category="sports"
          />
          <HomeExtra />
          <BharatAbroadAd />
          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Finance Section */}
          <NewsSection
            title="Finance News"
            articles={news.finance}
            category="finance"
          />
          <BharatAbroadAd />
          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Gossipe Section */}
          <NewsSection
            title="Entertainment Stories"
            articles={news.gossip}
            category="gossip"
          />

          <Movies />
          <br />
          <BharatAbroadAd />
        </div>
      </div>
    </>
  );
}

export default Home;
